<template>
    <section>
      <v-row class="d-none d-lg-block  mx-1 px-1">
            <v-col cols="12">
                <v-breadcrumbs
                    large
                    :items="crumbs"
                    divider="/"
                    light
                  ></v-breadcrumbs>
  
                    <h1 class="primary--text">
                      <v-icon color="primary">mdi-hard-hat</v-icon> <span>Registo Diário Encarregado</span>
                    </h1>

                    <v-btn @click="$router.push('/dashboard')" style="float: right;" class="primary">
                      <v-icon class="mr-2">mdi-view-dashboard</v-icon>
                      Dashboard
                    </v-btn>
  
                    <div class="mt-4">
                      <Supervisor method="create"></Supervisor>
                </div>
            </v-col>
        </v-row>

        <v-row class="d-block d-lg-none">
            <v-col cols="12">
                <v-breadcrumbs
                    large
                    :items="crumbs"
                    divider="/"
                    light
                  ></v-breadcrumbs>
  
                    <h1 class="primary--text">
                    <v-icon color="primary">mdi-hard-hat</v-icon> <span>Registo Diário Encarregado</span>
                    </h1>
  
                    <div class="mt-16">
                      <Supervisor method="create"></Supervisor>
                </div>
            </v-col>
        </v-row>
    </section>
  </template>
  <script>
  import Supervisor from '@/components/Diaries/Supervisor/Supervisor.vue'
  
  export default {
    components: {
        Supervisor
    },
    data: () => ({
      
    }),
    mounted(){       
      if(!this.$store.getters.hasRole(["super", "encarregado", "administrativo", "ceo", "engenheiro"])) {
          this.$router.push('/forbidden');
      } 
    },
    methods:{
    },
    computed: {
      crumbs: function() {
        return [
            {
                text: 'Registo Diário Encarregado',
                disabled: true,
                to: '#',
                exact: true,
            },
        ];
      }
    }
  };
  </script>
  